<div>
  <div class="header-actions-container">
    <app-upload-files-header
      title="Upload Files"
      description="Upload 1 file per slot below. Columns will be auto-detected. Add files if you have multiple files that have the required metadata."
    ></app-upload-files-header>

    <!-- TODO: Enable when clubs start sharing two files & also add logic to merge the files before upload to s3 -->
    <!-- <button nzSize="large" class="add-file-btn" nz-button (click)="addFile.emit()">+ Add Files</button> -->
  </div>

  <div class="required-list-container">
    <div class="required-list-panel mb24">
      <h3>Required Metadata List</h3>
      <span
        >List of required metadata. Uploaded files must contain atleast these columns. Column name can be different, as
        mapping will be in the next step. Additional columns are fine - they'll be ignored.</span
      >

      <div class="required-tag-section">
        <nz-tag nzColor="blue" class="target-tag" *ngFor="let field of fields; let i = index">
          {{ field.tagName }}
        </nz-tag>
      </div>
    </div>
    <div class="file-upload-header mb24" *ngFor="let file of files; let i = index">
      <span>File {{ i + 1 }}</span>
      <span *ngIf="i > 0" class="delete-btn" nz-icon nzType="delete" nzTheme="fill" (click)="removeFile.emit(i)"></span>
      <div class="file-upload-body">
        <form [formGroup]="file.fileForm" nz-form nzLayout="vertical">
          <div nz-row>
            <div nz-col nzSpan="8" class="file-name-input">
              <nz-form-item>
                <nz-form-label nzRequired nzFor="fileName" class="nfl-form-label">File Name</nz-form-label>
                <nz-form-control>
                  <input
                    nz-input
                    maxlength="45"
                    id="fileName"
                    nzSize="default"
                    placeHolder="Enter File Name"
                    formControlName="fileName"
                  />
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSpan="16" class="file-desc-input">
              <nz-form-item>
                <nz-form-label nzRequired nzFor="description" class="nfl-form-label">File Description</nz-form-label>
                <nz-form-control>
                  <input
                    nz-input
                    maxlength="45"
                    id="description"
                    nzSize="default"
                    placeHolder="Enter File Description"
                    formControlName="description"
                  />
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
          <div class="upload-box">
            <nz-upload
              nzType="drag"
              [nzMultiple]="false"
              [nzBeforeUpload]="getBeforeUploadHandler(i)"
              [nzShowUploadList]="true"
              [(nzFileList)]="file.uploadedFileList"
              accept=".csv"
            >
              <p class="ant-upload-drag-icon">
                <span nz-icon nzType="upload"></span>
              </p>

              <p><strong>Click to Upload</strong> or drag and drop the CSV file</p>

              <p class="upload-hint">Maximum file size 200MB</p>
            </nz-upload>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
